import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { victimologyColumns } from './VictimologyColumns'
import DataGrid from '../data-grid/DataGrid'
import { victimologyData } from './victimology-data'
import { useSelector } from 'react-redux'
import { selectUser } from '../../reducers/users'

function VictimologyWrapper() {
  const navigate = useNavigate()
  const { session } = useSelector(selectUser)

  useEffect(() => {
    const localSession = localStorage.getItem('session') as string
    if (localSession === '{}') {
      navigate('/login')
    }
  }, [])

  useEffect(() => {
    if (session?.portalPreferences?.threatIntelEvaluation == true) {
      navigate('/dashboard')
    }
  }, [session])

  return (
    <>
      <div className="absolute top-18 left-52 rounded-tl-lg border-t border-l w-[calc(100%_-_208px)] h-[calc(100%_-_74px)] border-mainBorder bg-contentBackground p-9 overflow-y-auto">
        <div className="bg-contentBackground h-full mx-auto">
          <div className="pb-9">
            <div className="grid grid-cols-1 gap-4 h-auto mb-4 min-h-[480px]">
              <DataGrid columns={victimologyColumns()} data={victimologyData} loading={false} />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default VictimologyWrapper
